import { supabase } from './supabase';

export const uploadMeme = async (canvas: HTMLCanvasElement, templateId: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(async (blob) => {
      if (!blob) {
        reject(new Error('Failed to create blob from canvas'));
        return;
      }

      const filename = `meme_${Date.now()}_${Math.random().toString(36).substr(2, 9)}.png`;
      
      try {
        const { data, error } = await supabase.storage
          .from('memes')
          .upload(filename, blob, {
            contentType: 'image/png',
            upsert: false
          });

        if (error) throw error;

        const { data: urlData } = supabase.storage
          .from('memes')
          .getPublicUrl(data.path);

        resolve(urlData.publicUrl);
      } catch (error) {
        reject(error);
      }
    }, 'image/png', 0.95);
  });
};